import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Auth from "@/pages/Auth";
import CustomerDashboard from "@/pages/CustomerDashboard";
import Marketplace from "@/pages/Marketplace";
import AdminDashboard from "@/pages/AdminDashboard";
import Verify from "@/pages/Verify";

function Protected({ children, role }) {
  const { user, ready } = useAuth();
  if (!ready || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <span className="font-mono text-sm text-orange-500 animate-pulse">
          [ loading portal... ]
        </span>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role)
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
}

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready || user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/verify" element={<Verify />} />
            <Route
              path="/dashboard"
              element={
                <Protected role="customer">
                  <CustomerDashboard />
                </Protected>
              }
            />
            <Route
              path="/marketplace"
              element={
                <Protected role="customer">
                  <Marketplace />
                </Protected>
              }
            />
            <Route
              path="/admin"
              element={
                <Protected role="admin">
                  <AdminDashboard />
                </Protected>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
